fragment FieldAnswerRuleFragment on AnswerChoiceRules {
    answerChoice {
        id
        name
    }
    objectsToAssign {
        ... on Tag {
            id
            name
        }
        ... on Audience {
            id
            name
        }
        ... on Product {
            id
            name
        }
        ... on Source {
            id
            name
        }
        ... on Stageset {
            id
            name
        }
    }
}
